import { queryOptions, useQuery } from '@tanstack/react-query';

import { socialPostsApi } from '../api/social-posts-api';
import { isRendering } from '../schemas/post-state';

import { socialKeys } from './social-keys';

export function socialPostQueryOptions(storeId: string, id: string) {
  return queryOptions({
    queryKey: socialKeys.post(storeId, id),
    queryFn: () => socialPostsApi.get(storeId, id),
  });
}

const RENDER_POLL_MS = 3_000;

/**
 * One post. While the backend's render job still owes a rendition the post is re-read every few
 * seconds so the preview and the Publish button follow; the interval is a pure function of the
 * data (no state set while rendering).
 */
export function useSocialPost(storeId: string, id: string) {
  return useQuery({
    ...socialPostQueryOptions(storeId, id),
    refetchInterval: (query) =>
      query.state.data && isRendering(query.state.data) ? RENDER_POLL_MS : false,
  });
}
